// extracted by mini-css-extract-plugin
export default {"MainContainer":"BgxXPw3WduHHc1HljVHQ","Content":"tZPxXzdjOFaDRdvLk6QE","PageContainer":"BI3wtzy8V4lHcGcCsVET"};